module.exports = __webpack_public_path__ + "static/img/icons8-chat_room.b94a18dc.svg";